import store from '@/store'
import DictUtil from '@/utils/dict.js'

export default (value) => {
  if (!value) {
    return '-'
  }

  let data = store.state.dictData[DictUtil.GROUP.trialStatus.value]
  if (!data || !data.length) {
    return '-'
  }

  let item = data.find(each => each.value === value)
  return item ? item.label : '-'
}



// WEBPACK FOOTER //
// ./src/filters/trialStatusFilter.js